import { $fn } from '../../y/fn';
import { $location } from '../../y/location';
import { $el } from '../elements';
import { UIClassesSpec } from '../types';

export namespace $vimeo {
    const link_regex = /^https.*vimeo\.com.*$/;

    export function isValidLink(link: string) {
        return link_regex.test(link);
    }

    export function player(url: string, classes?: UIClassesSpec) {
        const path = $location.getURL(url).pathname.split('/').filter($fn.ID);
        const id = path[path.length - 1];
        const iframe = $el.IFRAME('https://player.vimeo.com/video/' + id, classes);
        // iframe.setAttribute('allow', 'encrypted-media');
        return iframe;
    }
}
